var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullHeight"},[_c('div',{staticClass:"legenda"},_vm._l((_vm.stops),function(stop){return _c('div',{key:stop[0]},[_c('span',{style:({
          backgroundColor: stop[1],
          width: '0.7rem',
          height: '0.7rem',
          borderRadius: '50%',
          border: '1px solid grey',
          display: 'inline-block',
        })}),_c('span',{},[_vm._v(" "+_vm._s(stop[0])+" ")])])}),0),_c('div',{staticClass:"posicao-right"},[_c('div',[_c('md-button',{staticClass:"md-icon-button md-raised",on:{"click":_vm.centerMap}},[_c('md-icon',[_vm._v("my_location")])],1)],1)]),_c('div',{staticClass:"fullHeight",attrs:{"id":"mapContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }